import { CountryType } from "../../Patientregistration/v2/type/RegistrationDataType";

type CountryCodeSource = {
  countryCodeId?: number | null;
  countryCode?: {
    id?: number | string;
    country_id?: number;
  } | null;
};

export const resolveCountryById = (
  countryList: CountryType[] | undefined,
  countryId?: number | string | null,
): CountryType | null => {
  if (countryId == null || countryId === "" || !countryList?.length) return null;
  return countryList.find((c) => c.id == countryId) ?? null;
};

export const getDefaultCountryCode = (
  countryList: CountryType[] | undefined,
  isQatarRegion: boolean,
): CountryType => {
  const defaultCountry = countryList?.find((c) =>
    isQatarRegion
      ? c.isoCode === "QAT" || String(c.countryCode).includes("974")
      : c.isoCode === "ARE" || String(c.countryCode).includes("971"),
  );
  if (defaultCountry) return defaultCountry;
  if (countryList?.[0]) return countryList[0];
  return {
    id: isQatarRegion ? 172 : 227,
    countryCode: isQatarRegion ? "+974" : "971",
    countryName: isQatarRegion ? "Qatar" : "United Arab Emirates",
    isoCode: isQatarRegion ? "QAT" : "ARE",
    nationality: "",
  };
};

export const getCountryCodeForBooking = (
  source: CountryCodeSource | null | undefined,
  countryList: CountryType[] | undefined,
  isQatarRegion: boolean,
): CountryType => {
  const countryId =
    source?.countryCodeId ??
    source?.countryCode?.country_id ??
    source?.countryCode?.id;

  const fromId = resolveCountryById(countryList, countryId);
  if (fromId) return fromId;

  return getDefaultCountryCode(countryList, isQatarRegion);
};

export const resolveCountryId = (data: CountryCodeSource): number => {
  if (data?.countryCodeId != null && Number(data.countryCodeId) !== 0) {
    return Number(data.countryCodeId);
  }
  const fromCountryCode = data?.countryCode?.id ?? data?.countryCode?.country_id;
  if (
    fromCountryCode != null &&
    fromCountryCode !== "" &&
    Number(fromCountryCode) !== 0
  ) {
    return Number(fromCountryCode);
  }
  return 0;
};
